import Welfare from './index'
import Coupon from './Coupon'
import CouponRecord from './CouponRecord'
import UserType from './UserType'
import Task from './Task'
import TaskRecord from './TaskRecord'
import BonusStatistic from './BonusStatistic'
import PositionStatistic from './PositionStatistic'
import DeductStatistic from './CouponStatistic/DeductStatistic'
import TokenStatistic from './CouponStatistic/TokenStatistic'
import ExperiencePosition from './ExperiencePosition'

export default {
  path: '/home/welfare',
  component: Welfare,
  meta: { titie: '新福利中心' },
  children: [
    {
      path: '/home/welfare/coupon',
      meta: { titie: '卡券管理' },
      component: Coupon,
    },
    {
      path: '/home/welfare/couponRecord',
      meta: { titie: '卡券发放记录' },
      component: CouponRecord,
    },
    {
      path: '/home/welfare/userTypeManagement',
      meta: { titie: '用户类型管理' },
      component: UserType,
    },
    {
      path: '/home/welfare/management',
      meta: { titie: '任务管理' },
      component: Task,
    },
    {
      path: '/home/welfare/taskRecord',
      meta: { titie: '任务发放记录' },
      component: TaskRecord,
    },
    {
      path: '/home/welfare/experiencePosition',
      meta: { titie: '体验仓记录查询' },
      component: ExperiencePosition,
    },
    {
      path: '/home/welfare/feeDeductStats',
      alias: '/home/welfare/feeDeductStatistic',
      meta: { titie: '手续费抵扣券数据统计' },
      component: DeductStatistic,
      props: { title: '手续费抵扣券数据统计', kind: 'fee' },
    },
    {
      path: '/home/welfare/pnlDeductStats',
      alias: '/home/welfare/pnlDeductStatistic',
      meta: { titie: '盈亏抵扣券数据统计' },
      component: DeductStatistic,
      props: { title: '盈亏抵扣券数据统计', kind: 'pnl' },
    },
    {
      path: '/home/welfare/positionExperienceStats',
      alias: '/home/welfare/positionStatistic',
      meta: { titie: '仓位体验券数据统计' },
      component: PositionStatistic,
    },
    {
      path: '/home/welfare/tokenStats',
      alias: '/home/welfare/tokenStatistic',
      meta: { titie: '代币券数据统计' },
      component: TokenStatistic,
    },
    {
      path: '/home/welfare/bonusStatistic',
      alias: [
        '/home/welfare/bonusStatistics',
        '/home/welfare/bonus/statistic',
        '/home/welfare/bonusDataStatistic',
        '/home/welfare/experienceStatistic',
        '/home/welfare/experienceDataStatistics',
        '/home/welfare/experienceStats',
        '/home/welfare/statistics',
        '/home/welfare/dataStatistics',
      ],
      meta: { titie: '体验金数据统计' },
      component: BonusStatistic,
    },
  ],
}
